import { createFileRoute } from "@tanstack/react-router";

import { AttritionDashboard } from "../tools/dashboards/AttritionDashboard";

function AttritionRoute() {
  return <AttritionDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/attrition")({
  component: AttritionRoute,
});
